import { supabase } from './supabase'

export type NovaLimaBaseMetadata = {
  id: number
  source_filename: string
  checksum: string
  row_count: number
  imported_at: string
  imported_by: string | null
  archived_at?: string | null
}

export type NovaLimaStatus = {
  base_id: number | null
  row_count: number
  imported_at: string | null
  has_active_base: boolean
}

export type NovaLimaLookup = NovaLimaStatus & {
  matricula: string
  encontrada: boolean
}

export type NovaLimaAdminSnapshot = {
  active: NovaLimaBaseMetadata | null
  previous: NovaLimaBaseMetadata | null
  matriculas: string[]
}

export { checksumMatriculas, normalizeMatricula, parseMatriculaColumn } from './novaLimaMatriculaParser'
export type { MatriculaParseResult } from './novaLimaMatriculaParser'

import { normalizeMatricula } from './novaLimaMatriculaParser'

export async function loadNovaLimaStatus(): Promise<NovaLimaStatus> {
  const { data, error } = await supabase.rpc('nova_lima_base_status')
  if (error) throw error
  return data as NovaLimaStatus
}

export async function lookupNovaLimaMatricula(matricula: string): Promise<NovaLimaLookup> {
  const normalized = normalizeMatricula(matricula)
  if (!normalized) throw new Error('Informe uma matrícula válida usando somente números.')
  const { data, error } = await supabase.rpc('nova_lima_consultar_matricula', { p_matricula: normalized })
  if (error) throw error
  return data as NovaLimaLookup
}

export async function loadNovaLimaAdminSnapshot(): Promise<NovaLimaAdminSnapshot> {
  const { data, error } = await supabase.rpc('nova_lima_admin_snapshot')
  if (error) throw error
  return data as NovaLimaAdminSnapshot
}

export async function replaceNovaLimaBase(sourceFilename: string, checksum: string, matriculas: string[]) {
  const { data, error } = await supabase.rpc('nova_lima_replace_base', {
    p_source_filename: sourceFilename,
    p_checksum: checksum,
    p_matriculas: matriculas,
  })
  if (error) throw error
  return data as { id: number; source_filename: string; row_count: number; status: string }
}

export async function addNovaLimaMatricula(matricula: string) {
  const normalized = normalizeMatricula(matricula)
  if (!normalized) throw new Error('Informe uma matrícula válida usando somente números.')
  const { data, error } = await supabase.rpc('nova_lima_add_matricula', { p_matricula: normalized })
  if (error) throw error
  return data as { matricula: string; row_count: number }
}

export async function removeNovaLimaMatricula(matricula: string) {
  const normalized = normalizeMatricula(matricula)
  if (!normalized) throw new Error('Informe uma matrícula válida usando somente números.')
  const { data, error } = await supabase.rpc('nova_lima_remove_matricula', { p_matricula: normalized })
  if (error) throw error
  return data as { matricula: string; row_count: number }
}

export async function restoreNovaLimaPreviousBase() {
  const { data, error } = await supabase.rpc('nova_lima_restore_previous_base')
  if (error) throw error
  return data as { id: number; source_filename: string; row_count: number; status: string }
}
